const sortMenu = (array) => {
  return array.sort((a, b) => parseFloat(a.position) - parseFloat(b.position))
}

module.exports = (array) => {
  return sortMenu(array)
}
